import { Injectable } from '@angular/core';

import { ApiBaseService } from "../../common/providers/api-base-service";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Phase } from "../../common/models/phase";
import { Organization } from "../../common/models/organization";
import { CurrentUser } from "../../common/providers/current-user";

@Injectable({providedIn: 'root'})
export class PhaseProvider {
    constructor(
        private api: ApiBaseService,
        private currentUser: CurrentUser,
    ) {}

    public findAll(organization: Organization): Observable<Phase[]> {
        return this.api.call('get',`organizations/${organization.code}/plans/phases`, {}, this.currentUser.getAccessToken()).pipe(
            map((phases) =>  phases.map((phase: Phase) => Phase.fromAPI(phase, [phase])))
        );
    }
}
